'use strict';

/* global $ */

let settings = {
    selector: '.js-gallery',
    sliderSelector: '.js-gallery-slider',
    sliderContainerSelector: '.js-gallery-slider__list',
    sliderItemSelector: '.js-gallery-slider__item',
    sliderPrevSelector: '.js-gallery-slider__prev',
    sliderNextSelector: '.js-gallery-slider__next',
    sliderNavSelector: '.js-gallery-slider__nav',
    sliderOptions: {
        duration: 400,
        loop: true
    },
    scrollerSelector: '.js-gallery-scroller',
    scrollerContainerSelector: '.js-gallery-scroller__list',
    scrollerItemSelector: '.js-gallery-scroller__item',
    scrollerPrevSelector: '.js-gallery-scroller__prev',
    scrollerNextSelector: '.js-gallery-scroller__next',
    scrollerOptions: {
        duration: 200,
        hideArrs: true
    }
};

class Gallery {
    constructor(options) {
    	this.opt = $.extend({}, settings, options);
        this.init();
	}
    init() {
        console.log('[ Gallery/init ]');

        let self = this;
        let $blocks = $(this.opt.selector);
        $blocks.each(function() {
            let $block = $(this),
                $slider = $block.find(self.opt.sliderSelector),
                $scroller = $block.find(self.opt.scrollerSelector),
                $sliderItems = $slider.find(self.opt.sliderItemSelector),
                $scrollerItems = $scroller.find(self.opt.scrollerItemSelector);

            if ($scroller.length) {
                let $container = $scroller.find(self.opt.scrollerContainerSelector),
                    $prev = $scroller.find(self.opt.scrollerPrevSelector),
                    $next = $scroller.find(self.opt.scrollerNextSelector);

                $scrollerItems.scroller($.extend({}, self.opt.scrollerOptions, {
                    container: $container,
                    prev: $prev,
                    next: $next
                }));
            }

            if ($slider.length) {
                let $container = $slider.find(self.opt.sliderContainerSelector),
                    $prev = $slider.find(self.opt.sliderPrevSelector),
                    $next = $slider.find(self.opt.sliderNextSelector),
                    $nav = $slider.find(self.opt.sliderNavSelector);

                $sliderItems.slider($.extend({}, self.opt.sliderOptions, {
                    container: $container,
                    prev: $prev,
                    next: $next,
                    nav: $nav,
                    beforeChange: function(prevIdx, nextIdx, itemCount) {
                        if ($scrollerItems._scroller) {
                            $scrollerItems._scroller.scrollTo(nextIdx);
                        }
                    }
                }));
            }
        });
    }
}


export {
    Gallery
};
